
import React from "react";
import { Loader2 } from "lucide-react";
import { motion } from "framer-motion";
import { cn } from "@/lib/utils";

interface LoadingSpinnerProps {
  size?: number;
  color?: string;
  className?: string;
  text?: string;
}

export function LoadingSpinner({
  size = 24,
  color = "text-cta",
  className,
  text = ""
}: LoadingSpinnerProps) {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className={cn("flex flex-col items-center justify-center gap-3", className)}
    >
      <Loader2 
        className={cn("animate-spin", color)} 
        size={size} 
      />
      {text && (
        <motion.p
          initial={{ opacity: 0, y: 5 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2 }}
          className="text-sm text-muted-foreground"
        >
          {text}
        </motion.p>
      )}
    </motion.div>
  );
}
